export default __webpack_public_path__ + "static/media/staking.c79ee1ba.svg";